import React, { Component } from "react";
import "./ProductAuthenticityVerification.css";
import { useParams } from 'react-router-dom';
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import Page from "../../components/page/page";
import { getEducationById } from "../../constants/education-constants";

function ProductAuthenticityVerification() {

    const params = useParams();
    const education = [...getEducationById(1)];
    console.log("params.id : ", params.id);
    console.log("education : ", education);
    return (
        <Page>
            <Header />
            <section className="container news-content">
                <div className=" row hrow ">
                    <figure className="figure">
                        <figcaption className="figure-caption">
                            <h3>
                                بررسی اصالت کالا
                            </h3>
                            <span className="time">هوایار</span>
                        </figcaption>
                    </figure>
                    <img src={`../assets/images/general/approve.png`} className="figure-img img-fluid centerimg approveimg" alt="..." />
                </div>

                <div className="gray_container">
                    <h5 className="mb-4">کد کالا : 1806101002</h5>
                    <h5 className="mb-4">برند: مخزن هوای فشرده AR500 - 8bar</h5>
                    <h5 className="mb-4">ابعاد: 3 * 4 * 220000</h5>
                </div>
                <div className="gray_container">
                    <ul className="list-unstyled">
                        <li className="mb-3" key="111">
                            مخزن ذخیره هوای فشرده ، AC-AR-500 air receiver مخازن ذخیره ی هوا، برای هر سیستم هوای فشرده ای کاملا ضروری هستند. به دليل کاهش نوسانات فشار در سيستم هواي فشرده و ذخيره ي هوای فشرده از مخزن استفاده مي شود. و فشار آن از 8 تا 13 بار متغير مي باشد، درواقع هوای موردنياز سيستم برای زمان هاي اوج مصرف ذخيره می شود. تجهیزات مخزن ذخیره هوای فشرده 500-AC-AR ، به علت سطح تماس گسترده ای که با هوای محیط دارند، باعث خنک شدن هوای فشرده می شوند. و بخشی از رطوبت موجود در هوا را به صورت قطرات آب خارج می کنند. همچنین نوسانات فشار را که در شبکه ی هوا به وجود می آیند را کم کرده، جریان هوا را آرام نموده و فشار شبکه هوا را ثابت نگه می دارد.
                        </li>
                    </ul>
                </div>
                <section className="container ">
                    <div className="row hrow gray_container">
                        <a className="btn btn-dark" target="_blank" href={`../assets/pdf/Oil-Free-Compressor.pdf`} download>دریافت کاتالوگ</a>
                    </div>
                </section>
            </section>
            <Footer />
        </Page >
    );
}


export default ProductAuthenticityVerification;
